import { render, staticRenderFns } from "./Coefficient.vue?vue&type=template&id=65e24cad&"
import script from "./Coefficient.vue?vue&type=script&lang=js&"
export * from "./Coefficient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports